import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Grid,
  LinearProgress,
  IconButton,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPendingPromotions,
  reviewPromotion,
  downloadScreenshot,
} from "../../store/Slices/promotionSlice";
import PendingCard from "./components/PendingCard";
import ReviewDialog from "./components/ReviewDialog";

export default function PromotionReviewPage() {
  const dispatch = useDispatch();
  const { pending, loadingPending, reviewLoading } = useSelector(
    (s) => s.promotion
  );

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [reason, setReason] = useState("");

  useEffect(() => {
    dispatch(fetchPendingPromotions());
  }, [dispatch]);

  const onOpenReview = (row) => {
    setSelected(row);
    setReason("");
    setOpen(true);
  };
  const onCloseReview = () => {
    setOpen(false);
    setSelected(null);
    setReason("");
  };

  const onApprove = () => {
    if (!selected) return;
    dispatch(reviewPromotion({ id: selected._id, status: "approved" })).then(
      (r) => {
        if (!r.error) onCloseReview();
      }
    );
  };
  const onReject = () => {
    if (!selected) return;
    dispatch(
      reviewPromotion({
        id: selected._id,
        status: "rejected",
        review_reason: reason,
      })
    ).then((r) => {
      if (!r.error) onCloseReview();
    });
  };

  const onDownload = (row) => {
    dispatch(
      downloadScreenshot({
        id: row._id,
        filename: row.screenshot_original_name,
      })
    );
  };

  return (
    <Box sx={{ p: 2, maxWidth: 1300, mx: "auto" }}>
      <Card sx={{ borderRadius: 3, boxShadow: 6 }}>
        <CardHeader
          title="Promotion Pending Queue"
          action={
            <IconButton onClick={() => dispatch(fetchPendingPromotions())}>
              <RefreshIcon />
            </IconButton>
          }
        />
        <CardContent>
          {loadingPending && <LinearProgress sx={{ mb: 2 }} />}
          <Grid container spacing={2}>
            {pending.map((row) => (
              <Grid item xs={12} md={6} key={row._id}>
                <PendingCard
                  row={row}
                  onDownload={onDownload}
                  onOpenReview={onOpenReview}
                />
              </Grid>
            ))}
            {!pending.length && !loadingPending && (
              <Grid item xs={12}>
                <Typography sx={{ opacity: 0.7 }}>
                  لا توجد طلبات قيد المراجعة حاليًا.
                </Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>

      <ReviewDialog
        open={open}
        onClose={onCloseReview}
        selected={selected}
        reason={reason}
        setReason={setReason}
        onApprove={onApprove}
        onReject={onReject}
        reviewLoading={reviewLoading}
      />
    </Box>
  );
}
